import { useState } from "react";

import { Button, Grid2, Stack, Typography } from "@mui/material";
import { IconBuildings } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";

import { spacesList } from "../services/spaces";
import SpacesTableComponent from "../components/SpacesTableComponent";
import SpacesRegister from "../components/SpacesRegister";
import PageHeader from "../components/PageHeader";
import ContainerLoading from "../components/ContainerLoading";

const Spaces = () => {
  const [open, setOpen] = useState(false);

  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      name: string;
      description: string;
      createdAt: string | Date;
      status: boolean;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["spacesList"],
    queryFn: async () => await spacesList({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Espaços"
          subtitle="Informações gerais dos seus espaços."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconBuildings size={18} />
                <Typography variant="body2">Cadastrar espaço</Typography>
              </Button>
            </Stack>
          }
        />

        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={6}>
              <Stack sx={{ justifyContent: "center", height: "100%" }}></Stack>
            </Grid2>
            <Grid2 size={12}>
              <SpacesTableComponent data={data} refetch={() => refetchAll()} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <SpacesRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Spaces;
